import React, { useContext } from 'react';
import { useState } from "react";
import PageHeader from '../components/PageHeader';
import DropDownQuestion from '../components/DropDownQuestion';
import Sorters from '../components/Sorters';
import Pager from '../components/Pager';
import Loading from '../components/Loading';
import useDocumentTitle from '../components/useDocumentTitle';

import MyQuestionsContext from '../context/QuestionsContext';

const Questions = () => {
    useDocumentTitle("Preguntas Frecuentes");
    const { setSorters, setPage, useQuestions, maxPage } = useContext(MyQuestionsContext);
    const { questions, isLoading, isError } = useQuestions();

    const [open, setOpen] = useState(0);

    const handleOpen = (value) => {
        setOpen(open === value ? 0 : value);
    };

    return (
        <div>
            <PageHeader tittle="PREGUNTAS FRECUENTES" />

            <div className='w-[91%] mx-auto my-14 '>
                <div className='w-[50%] sm:w-[35%] lg:w-[15%] mx-auto mt-2 mb-4'>
                    <Sorters setSorters={setSorters} />
                </div>

                <Loading isLoading={isLoading} />

                {questions ? questions.length > 0 ? questions.map((question, index) => (
                    <DropDownQuestion handleOpen={handleOpen} open={open} index={index} question={question.questionTitle} answer={question.questionAnswer} />
                )) : <h1 className='text-center w-full font-light mt-4 '>No hay registros para mostrar</h1> : null
                }

                {isError ? <h1 className='text-center text-red-500 w-full mb-4'>Ha ocurrido un error al cargar los datos.</h1> : null}
                {maxPage < 1 ? null : <div className='flex justify-center mb-4'>
                    <Pager maxPage={maxPage} setPage={setPage} />
                </div>}

                
            </div>

        </div>
    );
}

export default Questions;


